export const defaultEnv = {
    cobShowcase: false,
    production: false,
    api: {
        graphQLSuffix: `graphql`,
    },
    withDebugTracing: false,
};
